require.register("app/supplier/show/RestaurantTab", function(exports, require, module){
  $0
  
});

